//crea un modal para cuando el usuario no ha iniciado sesion



// Path: src/pages/other/ModalCuenta.js

import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// import { useAuth } from '../../contexts/AuthContext';
//import { useHistory } from 'react-router-dom';
import { setUsuario } from '../../store/slices/user-slice';
import { useDispatch } from 'react-redux';

const ModalCuenta = ({ showModalCuenta, handleClose }) => {

    const dispatch = useDispatch();
const continuarInvitado = () => {
    //console.log("continuar como invitado")
    //ejecutar setusuario con dispatch
    dispatch(setUsuario({
        apellidos: "",
        direcciones: [],
        displayName: "",
        email: "",
        fono: "",
        nombre: "",
        origen: "",
        photoURL: "",
        rut: "",
        tipo: "",
        uid: "",
        estado: "invitado"
    }))

    handleClose();
}
    // const { currentUser, logout } = useAuth();
    //const history = useHistory();



    // async function handleLogout() {
    //     try {
    //         await logout();
    //         history.push('/login');
    //     } catch (error) {
    //         //console.log(error);
    //     }
    // }

    return (
        <>
            <Modal show={showModalCuenta} className='sin-cuenta'>
                <Modal.Header>
                    <Modal.Title className='titulo'>No has iniciado sesión</Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-4'>
                    <div>
                        <p className="inicio">Accede a tu cuenta para guardar tus recetas, comprar para diferentes miembros de tu familia, guardar tus direcciones y ver o repetir compras anteriores en la plataforma.</p>

                    </div>
                    <div>
                        <p className="sub-titulo">¿No tienes cuenta?</p>
                        <p className="texto">
                            Registrate aquí
                        </p>
                        <Link className='boton-registro' to="/registro">REGISTRO</Link>

                    </div>
                    <div>
                    <p className="sub-titulo">¿Ya tienes una cuenta?</p>
                    <p className="texto">
                            Inicia sesión aquí
                        </p>
                        <Link className='boton-login' to="/login">INICIAR SESIÓN</Link>
                    </div>
                    <div>
                    <p className="sub-titulo">O puedes continuar como invitado</p>
                        <Button onClick={()=> continuarInvitado()} className='boton boton-login'>CONTINUAR COMO INVITADO</Button>

                    </div>
                </Modal.Body>

            </Modal>
        </>
    );
}

export default ModalCuenta;